import protobuf from "protobufjs";
import { Type } from "./proto-root";

export { default } from "./proto-root";

function encode(buffer) {
  return protobuf.util.base64.encode(buffer, 0, buffer.length);
}

export function encodeCurrentState(currentState) {
  const currentStateMessage = Type.CurrentStateMessage.create(currentState);
  const buffer = Type.CurrentStateMessage.encode(currentStateMessage).finish();

  return encode(buffer);
}
